import { render, staticRenderFns } from "./HomePodcastsCarousel.vue?vue&type=template&id=3056dc79&scoped=true&"
import script from "./HomePodcastsCarousel.vue?vue&type=script&lang=js&"
export * from "./HomePodcastsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./HomePodcastsCarousel.vue?vue&type=style&index=0&id=3056dc79&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3056dc79",
  null
  
)

export default component.exports